import { render, staticRenderFns } from "./MedicalHistory.vue?vue&type=template&id=6dd178bc&"
import script from "./MedicalHistory.vue?vue&type=script&lang=js&"
export * from "./MedicalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports